// @ts-nocheck
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CREATE_INWARD_CONNECTION,
  DELETE_INWARD_CONNECTION,
  EditINward,
  Get_Inwerd_By_Id,
  GET_LOAD_RECEIPT,
  getFormSectionsAndFields,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import MemoMainComponent from "../../LRTable/MemoMainComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import "./AddInwardConnection.scss";
import { InwardInputFields } from "./InwardConnectionConfig";
import InwardInputs from "./InwardInputs";
import { IsoToDateWithoutTime, convertToISO } from "../../../../CommonFunction/IsoDateTime";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { ConvertDateValues } from "../../../custom_hooks/ChangeDateValues";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  ClearFields,
  handleFormReset,
  updateSingleField,
  updateValueForm,
} from "../../FormInputSectionComponent/formUtils";
import { AtomFormState } from "../../../../atoms/FormAtom";
import { useRecoilState } from "recoil";
import { RiErrorWarningFill } from "react-icons/ri";

const AddInwardConnection = ({
  show,
  TypeOfPortal,
  fielddata,
  submitType,
  ParentPortalCloseFunction,
  openByCard,
  FormDetailsByCard,
  openByCardId
}) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Warehouse Inward");
  const [openModal, setOpenModal] = useState(show ? show : false);
  const dispatch = useDispatch();
  const Form_key = "Inward_Connection";
  const FormDataFromRedux = useSelector((store: any) => store.FormDataReducer);
  const [LRData, setLRData] = useState<any[]>([]);
  const [LRList, setLRList] = useState<any[]>([]);
  const [LRData1, setLRData1] = useState<any[]>([]);
  const [createdMemo, setCreatedMemo] = useState(false);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const SelectdRow = fielddataRedux?.Inward_Connection?.Selected_Row;
  const [FormData, setFormdata] = useState<any>({});
  const [FormValue, setFormValue] = useRecoilState(AtomFormState(Form_key));
  const [InputFields, setInputFields] = useState([]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [currentBranch, setCurrentBranch] = useState("");
  const formRef = useRef({});
  const [GetById, { loading: getLoading }] = useLazyQuery(Get_Inwerd_By_Id, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
    fetchPolicy: "network-only",
  });
  const { pushModal, popModal } = useModalContext();
  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_key,
      },
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setInputFields(data?.formSectionAndFields);
      },
    }
  );
  const {
    loading: LRloading,
    data: LRdata,
    refetch: LRRefetch,
  } = useQuery(GET_LOAD_RECEIPT, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
    variables: {
      Type: "Inward Connection Center",
      warehouseId: FormDataFromRedux?.MasterData?.[Form_key]?.Received_At?._id,
    },
    fetchPolicy: "network-only",
  });
  const [CreateInwardConnection, { loading: AddLoading, error }] = useMutation(CREATE_INWARD_CONNECTION, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
  });
  const [DeleteInwardConnection, { loading: DeleteLoading }] = useMutation(DELETE_INWARD_CONNECTION, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
  });
  const [Edit_Inward_Memo, { loading: EditLoading }] = useMutation(EditINward, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
    onCompleted: () => {
      Closeformfunction1();
      dispatch({ type: "Refetch", payload: true });
      SuccessToast(`Warehouse Inward edited sucessfully `);
    },
    onError: (err) => {
      ErrorToast(`${err.message}`);
    },
  });
  const LoadingState = AddLoading || getLoading || EditLoading || LRloading ? true : false;
  const [allFieldsData, setAllFieldsData] = useState();

  // Handle errors received from FormInputSectionComponent
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...newErrors,
    }));
  };

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    if (FormData?.Mode && isFirstLoad) {
      setFormValue({ Mode: FormData?.Mode });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_key,
          data: {
            Vehicle_No: {},
          },
        },
      });
      updateSingleField(formRef, "Vehicle_No", "");
    }
  }, [FormData?.Mode]);

  useEffect(() => {
    pushModal(Form_key);
    return () => {
      popModal(Form_key);
    };
  }, []);
   
  useEffect(() => {
    setSelectedRows(fielddataRedux?.Inward_Connection?.SelRows_ids);
  }, [fielddataRedux]);

  useEffect(() => {
    if (FormDataFromRedux?.MasterData?.[Form_key]?.Driver_Name) {
      let obj = FormDataFromRedux?.MasterData?.[Form_key]?.Driver_Name;
      updateSingleField(formRef, "Driver_Number", obj?.Mobile_Number);
    }
  }, [FormDataFromRedux?.MasterData[Form_key]?.Driver_Name]);

  useEffect(() => {
    const value = FormDataFromRedux?.MasterData[Form_key]?.Branch_Code;
    if (TypeOfPortal === "Add" && value && currentBranch && currentBranch?._id !== value?._id && !openByCard) {
      ClearSpecificForm(dispatch, Form_key);
      ClearFields(formRef);
      LRRefetch({
        variables: {
          Type: "Inward Connection Center",
          warehouseId: FormDataFromRedux?.MasterData?.[Form_key]?.Received_At?._id,
        }
      }).then((res) => console.log(res));
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_key,
          data: {
            Branch_Code: value,
          },
        },
      });
    }
    setCurrentBranch(value);
  }, [FormDataFromRedux?.MasterData[Form_key]?.Branch_Code]);

  useEffect(() => {
    if (FormDataFromRedux?.MasterData?.[Form_key]?.From_Connection_Center?._id) {
      LRRefetch({
        variables: {
          Type: "Inward Connection Center",
          warehouseId: FormDataFromRedux?.MasterData?.[Form_key]?.Received_At?._id,
        }
      }).then((res) => console.log(res));
    }
  }, [FormDataFromRedux?.MasterData?.[Form_key]?.From_Connection_Center?._id]);

  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (LRData.length === 0) {
      return WarningToast("Please Select at Least 1 Lr");
    } else if (!Error) {
      submit();
    }
  };
  const Closeformfunction1 = () => {
    handleFormReset(formRef);
    ClearSpecificForm(dispatch, Form_key);
    setOpenModal(false);
    ParentPortalCloseFunction();
  };

  useEffect(() => {
    if (LRdata && TypeOfPortal === "Add") {
      setLRList(ConvertDateValues(LRdata.getLoadReceiptData_WithPopulate));
    }
  }, [LRdata]);

  useEffect(() => {
    if (LRdata && (TypeOfPortal === "Edit" || TypeOfPortal === "View")) {
      let lr = ConvertDateValues(LRdata.getLoadReceiptData_WithPopulate) || [];
      let lr2 = ConvertDateValues(allFieldsData?.LoadReceiptsData) || [];
      setLRList((prev) => [...prev, ...lr, ...lr2]);
    }
  }, [LRdata, allFieldsData]);

  useEffect(() => {
    if (InputFields.length) {
      if (!TypeOfPortal?.includes("Add")) {
        GetById({
          variables: {
            getInwardAtConnectionCentreByIdWithLrId: openByCard ? openByCardId : SelectdRow?._id,
          },
        }).then(({ data }) => {
          let MemoData = { ...data?.getInwardAtConnectionCentreByIdWithLR[0] };
          delete MemoData.__typename;
          setLRData1(ConvertDateValues(MemoData?.LoadReceiptsData));
          setLRData(ConvertDateValues(MemoData?.LoadReceiptsData));

          MemoData.Date = IsoToDateWithoutTime(MemoData.Date);
          MemoData.Vehicle_No = MemoData?.Vehicle_No?.Vehicle_No;
          MemoData.Driver_Name = MemoData?.Driver_Name?.Name;
          MemoData.Received_At = MemoData?.Received_At_Data?.Warehouse_Name;
          updateValueForm(formRef, MemoData);
          setAllFieldsData(MemoData);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_key,
              data: {
                Driver_Name: MemoData?.Driver_ID_Data,
                Vehicle_No: MemoData.Vehicle_No_Data,
                Received_At: MemoData.Received_At_Data,
                Branch_Code: MemoData?.Branch_Code_Data,
              },
            },
          });
        });
      } else {
        if (openByCard) {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_key,
              data: {
                Received_At: {
                  _id: FormDetailsByCard?.PickupMemo_Data?.Drop_At_Data?._id,
                  Search_Value: FormDetailsByCard?.PickupMemo_Data?.Drop_At_Data?.Warehouse_Name,
                },
                Vehicle_No: {
                  _id:
                    FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?._id ||
                    FormDetailsByCard?.pickup_Updation_Data?.Vehicle_No_Data?._id,
                  Search_Value:
                    FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?.RC_Number ||
                    FormDetailsByCard?.pickup_Updation_Data?.Vehicle_No_Data?.RC_Number,
                },
                Driver_Name: {
                  _id:
                    FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?._id ||
                    FormDetailsByCard?.pickup_Updation_Data?.Driver_Name_Data?._id,
                  Search_Value:
                    FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?.Name ||
                    FormDetailsByCard?.pickup_Updation_Data?.Driver_Name_Data?.Name,
                  Mobile_Number:
                    FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?.Mobile_Number ||
                    FormDetailsByCard?.pickup_Updation_Data?.Driver_Name_Data?.Mobile_Number,
                },
                Branch_Code: FormDetailsByCard?.pickup_Updation_Data?.Branch_Code_Data || FormDetailsByCard?.PickupMemo_Data?.Branch_Code_Data,
              },
            },
          });
          // console.log(FormDetailsByCard?.pickup_Updation_Data?.Vehicle_No_Data?.RC_Number, "pickup_Updation_Data");
          updateSingleField(formRef, "Date", GetTodaysDateINdmy());
          updateSingleField(
            formRef,
            "Branch_Code",
            FormDetailsByCard?.pickup_Updation_Data?.Branch_Code_Data?.Search_Value || FormDetailsByCard?.PickupMemo_Data?.Branch_Code_Data?.Search_Value
          );
          updateSingleField(formRef, "Received_At", FormDetailsByCard?.PickupMemo_Data?.Drop_At_Data?.Warehouse_Name);
          updateSingleField(formRef, "Mode", FormDetailsByCard?.PickupMemo_Data?.Mode ||
            FormDetailsByCard?.pickup_Updation_Data?.Mode);
          if (FormDetailsByCard?.pickup_Updation_Data?.Mode == "Truck" || FormDetailsByCard?.PickupMemo_Data?.Mode == "Truck") {
            updateSingleField(
              formRef,
              "Vehicle_No",
              FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?.RC_Number ||
              FormDetailsByCard?.pickup_Updation_Data?.Vehicle_No_Data?.RC_Number
            );
          } else {
            updateSingleField(
              formRef,
              "Vehicle_No",
              FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?.Vehicle_No ||
              FormDetailsByCard?.pickup_Updation_Data?.Vehicle_No_Data?.Vehicle_No
            );
          }

          updateSingleField(
            formRef,
            "Driver_Name",
            FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?.Name ||
            FormDetailsByCard?.pickup_Updation_Data?.Driver_Name_Data?.Name
          );
          setLRData1(ConvertDateValues(FormDetailsByCard?.LR_Data));
        } else {

          updateSingleField(formRef, "Date", GetTodaysDateINdmy());
          updateSingleField(formRef, "Mode", "Truck");
        }
      }
    }
  }, [SelectdRow, InputFields]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const submit = async (close) => {
    const idArray = LRData.map((item: any) => item._id);
    let data: any = { ...FormData };
    data.LoadReceiptsIds = idArray;
    let convertedDate = data?.Date ? convertToISO(data?.Date) : null;
    data.Date = convertedDate;
    let Vehicle_No = FormDataFromRedux.MasterData?.[Form_key]?.Vehicle_No?._id;
    let Driver = FormDataFromRedux.MasterData?.[Form_key]?.Driver_Name?._id;
    data.Received_At = FormDataFromRedux.MasterData?.[Form_key]?.Received_At?._id;
    data.Vehicle_No = Vehicle_No;
    data.Driver_Name = Driver;
    data.Driver_Number = data.Driver_Number ? String(data.Driver_Number) : null;
    if (TypeOfPortal.includes("Edit")) {
      Edit_Inward_Memo({
        variables: {
          editInwardAtConnectionCentreId: openByCard ? openByCardId : SelectdRow?._id,
          userInput: data,
        },
      });
    } else {
      await CreateInwardConnection({
        variables: {
          InwardAtConnectionCentreInput: data,
        },
      })
        .then((res) => {
          SuccessToast("Warehouse Inward Created Successfully");
          dispatch({ type: "Refetch", payload: true });
          if (close) {
            Closeformfunction1();
          } else {
            handleFormReset(formRef);
            ClearSpecificForm(dispatch, Form_key);
            setCreatedMemo(true);
            setTimeout(() => {
              setCreatedMemo(false);
            }, 100);
            setLRList(prev => [])
            LRRefetch({
              variables: {
                Type: "Inward Connection Center",
                warehouseId: FormDataFromRedux?.MasterData?.[Form_key]?.Received_At?._id,
              }
            }).then((res) => console.log(res));
            updateValueForm(formRef, {
              Date: GetTodaysDateINdmy(),
              Mode: "Truck",
            });
            dispatch({ type: "Refetch", payload: true });
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  let handleDeleteUpdation = async () => {
    await DeleteInwardConnection({
      variables: {
        idsToDelete: selectedRows,
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast("Pickup Assignment Deleted Successfully");
        Closeformfunction1();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  }

  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={openModal} onClose={() => setOpenModal(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={handleDeleteUpdation}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            setOpenModal(false);
          }}
          loadingState={DeleteLoading}
        />
      </Reactportal>
    );
  }



  return (
    <>
      {openModal ? (
        <Reactportal
          open={openModal}
          onClose={Closeformfunction1}
          TypeOfPortal={modifiedTypeOfPortal}
          Form_Key={Form_key}
          ShowBranchInput={true}
        >
          {LoadingState && <div className="loader-line-div" />}
          <div className="InwardMaindiv">
            <div className="horizontalcontainer">
              {InputFields &&
                InputFields.map((e) => {
                  return (
                    <div key={e.id} className="">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="horizantalSection insidecontainer">
                        <FormInputSectionComponent
                          inputfields={e.fields}
                          Type={e.name}
                          onhandleFormikChange={HanldeChangeonForm}
                          validation_Schema={e?.Valid_schema}
                          onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                          formkey={Form_key}
                          formRef={formRef}
                          setFirstLoad={setFirstLoad}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="InwardLRTable">
              <MemoMainComponent
                TypeofPortal={`Inward At Warehouse ${TypeOfPortal}`}
                data={LRList}
                fielddata={""}
                createdMemo={createdMemo}
                totalWeight={(val: number) => { }}
                setLR={(val) => setLRData(val)}
                SelectedData={LRData1}
                formkey={Form_key}
                openByCard={openByCard}
              />
            </div>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitType={submitType}
            Form_key={Form_key}
            TypeOfPortal={TypeOfPortal}
            submitform={() => {
              Validate_handleSubmit(submit);
            }}
            SaveAndClose={() => {
              Validate_handleSubmit(() => {
                submit("close");
              });
            }}
            handleformclose={() => {
              setOpenModal(!openModal);
              Closeformfunction1();
            }}
            loadingState={LoadingState}
          />
        </Reactportal>
      ) : (
        <div></div>
      )}
    </>
  );
};
export default AddInwardConnection;
